type Props = {
  size?: 'large' | 'small';
};

export const CloseIcon = ({ size = 'large' }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size === 'large' ? '25' : '15'}
      height={size === 'large' ? '25' : '15'}
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.4718 4.79289C4.8786 4.40237 5.53814 4.40237 5.94494 4.79289L20.5283 18.7929C20.9351 19.1834 20.9351 19.8166 20.5283 20.2071C20.1215 20.5976 19.4619 20.5976 19.0551 20.2071L4.4718 6.20711C4.065 5.81658 4.065 5.18342 4.4718 4.79289Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.4718 20.2072C4.06501 19.8167 4.06501 19.1835 4.4718 18.793L19.0551 4.79299C19.4619 4.40246 20.1215 4.40247 20.5283 4.79299C20.9351 5.18351 20.9351 5.81668 20.5283 6.2072L5.94494 20.2072C5.53815 20.5977 4.8786 20.5977 4.4718 20.2072Z"
        fill="currentColor"
      />
    </svg>
  );
};
